<template>
     <!-- Main Sidebar Container -->
     <aside class="main-sidebar elevation-4 sidebar-light-custom">    <!-- Brand Logo -->
    <router-link :to="{ name:'dashboard' }" class="brand-link" @click="seleecionarMenu('dashboard','')">
      <img src="./../dist/img/logoVenta.png" alt="AdminLTE Logo" class="brand-image img-circle elevation-3" style="opacity: .8">
      <span class="brand-text font-weight-light">VentaXpress</span>
    </router-link>

    <!-- Sidebar -->
    <div class="sidebar">
      <!-- Sidebar user panel (optional) -->
      <div class="user-panel mt-3 pb-3 mb-3 d-flex">
        <div class="image">
          <img src="./../dist/img/usuario.png" class="" alt="User Image">
        </div>
        <div class="info">
          <a>{{ nombreUsuario }}</a>
        </div>
      </div>

      <!-- SidebarSearch Form -->
      <!--<div class="form-inline">
        <div class="input-group" data-widget="sidebar-search">
          <input class="form-control form-control-sidebar" type="search" placeholder="Search" aria-label="Search">
          <div class="input-group-append">
            <button class="btn btn-sidebar">
              <i class="fas fa-search fa-fw"></i>
            </button>
          </div>
        </div>
      </div>
    -->
      <!-- Sidebar Menu -->
      <nav class="mt-2">
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
          <!-- Add icons to the links using the .nav-icon class
               with font-awesome or any other icon font library -->
          
          
            <li class="nav-item">
              <router-link :to="{name:'dashboard'}" class="nav-link"
                :class="{'active':menuSeleccionado==='dashboard'}" 
                @click="seleecionarMenu('dashboard','')">
                <i class="nav-icon fas fa-th"></i>
                <p>Dashboard</p>
              </router-link>
            </li>
            
            <li class="nav-item"  v-if="tipoUsuario == 1 || tipoUsuario == 2 || tipoUsuario == 3 || tipoUsuario == 4">
                <a href="#" class="nav-link" :class="{'active':menuPrincipal==='ventas'}">
                  <i class="nav-icon fab fa-shopify"></i>
                  <p>
                    Ventas
                    <i class="right fas fa-angle-left"></i>
                  </p>
                </a>
                <ul class="nav nav-treeview">
                    <li class="nav-item" v-if="tipoUsuario == 1 || tipoUsuario == 3 || tipoUsuario == 4">
                      <router-link :to="{name:'nuevopedido'}" class="nav-link"
                      :class="{'active':menuSeleccionado==='nuevopedido'}"
                      @click="seleecionarMenu('nuevopedido','ventas')">
                        <i class="far fa-circle nav-icon"></i>
                        <p>
                        Nueva venta
                        </p>
                      </router-link>
                    </li>
                </ul>
                <ul class="nav nav-treeview">
                    <li class="nav-item" v-if="tipoUsuario == 1 || tipoUsuario == 2 || tipoUsuario == 4">
                      <router-link :to="{name:'caja'}" class="nav-link"
                      :class="{'active':menuSeleccionado==='caja'}"
                      @click="seleecionarMenu('caja','ventas')">
                        <i class="nav-icon far fa-circle"></i>
                        <p>
                        Cobrar
                        </p>
                      </router-link>
                    </li>
                  </ul>
                <ul class="nav nav-treeview">
                  <li class="nav-item" v-if="tipoUsuario == 1 || tipoUsuario == 3 || tipoUsuario == 4">
                    <router-link :to="{name:'pedidos'}" class="nav-link"
                    :class="{'active':menuSeleccionado==='pedidos'}"
                    @click="seleecionarMenu('pedidos','ventas')">
                      <i class="far fa-circle nav-icon"></i>
                      <p>
                      Pedidos
                      </p>
                    </router-link>
                  </li>
                </ul>
                <ul class="nav nav-treeview">
                  <li class="nav-item" v-if="tipoUsuario == 1 || tipoUsuario == 2 || tipoUsuario == 4">
                    <router-link :to="{name:'ventas'}" class="nav-link"
                    :class="{'active':menuSeleccionado==='ventas'}"
                    @click="seleecionarMenu('ventas','ventas')">
                      <i class="nav-icon far fa-circle"></i>
                      <p>
                      Mis ventas
                      </p>
                    </router-link>
                  </li>
                </ul>
                <ul class="nav nav-treeview">
                  <li class="nav-item" v-if="tipoUsuario == 1 || tipoUsuario == 2 || tipoUsuario == 4">
                    <router-link :to="{name:'reporteventas'}" class="nav-link"
                    :class="{'active':menuSeleccionado==='reporteventas'}"
                    @click="seleecionarMenu('reporteventas','ventas')">
                      <i class="nav-icon far fa-circle"></i>
                      <p>
                      Reporte de ventas
                      </p>
                    </router-link>
                  </li>
                </ul>
                <ul class="nav nav-treeview">
                  <li class="nav-item" v-if="tipoUsuario == 1 || tipoUsuario == 2 || tipoUsuario == 4">
                    <router-link :to="{name:'notacredito'}" class="nav-link"
                    :class="{'active':menuSeleccionado==='notacredito'}"
                    @click="seleecionarMenu('notacredito','ventas')">
                      <i class="nav-icon far fa-circle"></i>
                      <p>
                      Notas de Créditos
                      </p>
                    </router-link>
                  </li>
                </ul>
              </li>
            
              <li class="nav-item"  v-if="tipoUsuario == 1">
                <a href="#" class="nav-link" :class="{'active':menuPrincipal==='inventario'}">
                  <i class="nav-icon fas fa-dolly-flatbed"></i>
                  <p>
                    Inventarios
                    <i class="right fas fa-angle-left"></i>
                  </p>
                </a>
                <ul class="nav nav-treeview">
                  <li class="nav-item">
                    <router-link :to="{name:'compras'}" class="nav-link"
                      :class="{'active':menuSeleccionado==='compras'}" 
                      @click="seleecionarMenu('compras','inventario')">
                      <i class="far fa-circle nav-icon"></i>
                      <p>Compras</p>
                    </router-link>
                  </li>
                </ul>
                <ul class="nav nav-treeview">
                  <li class="nav-item">
                    <router-link :to="{name:'stock'}" class="nav-link"
                      :class="{'active':menuSeleccionado==='stock'}" 
                      @click="seleecionarMenu('stock','inventario')">
                      <i class="far fa-circle nav-icon"></i>
                      <p>Stock</p>
                    </router-link>
                  </li>
                </ul>
                <ul class="nav nav-treeview">
                    <li class="nav-item">
                      <router-link :to="{name:'precioproducto'}" class="nav-link"
                        :class="{'active':menuSeleccionado==='precioproducto'}" 
                        @click="seleecionarMenu('precioproducto','inventario')">
                        <i class="far fa-circle nav-icon"></i>
                        <p>Precios y SKU</p>
                      </router-link>
                    </li>
                  </ul>
                  <ul class="nav nav-treeview">
                    <li class="nav-item">
                      <router-link :to="{name:'entradasalida'}" class="nav-link"
                        :class="{'active':menuSeleccionado==='entradasalida'}" 
                        @click="seleecionarMenu('entradasalida','inventario')">
                        <i class="far fa-circle nav-icon"></i>
                        <p>Entrada y Salida</p>
                      </router-link>
                    </li>
                  </ul>
              </li>

              <li class="nav-item"  v-if="tipoUsuario == 1">
                <a href="#" class="nav-link" :class="{'active':menuPrincipal==='mantenedores'}">
                  <i class="nav-icon fas fa-cogs"></i>
                  <p>
                    Mantenedores
                    <i class="right fas fa-angle-left"></i>
                  </p>
                </a>
                <ul class="nav nav-treeview">
                  <li class="nav-item">
                    <router-link :to="{ name: 'unidadmedida'}" class="nav-link"
                      :class="{'active':menuSeleccionado==='unidadmedida'}" 
                      @click="seleecionarMenu('unidadmedida','mantenedores')">
                      <i class="far fa-circle nav-icon"></i>
                      <p>Unidad medida</p>
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link :to="{name:'categorias'}" class="nav-link"
                      :class="{'active':menuSeleccionado==='categorias'}" 
                      @click="seleecionarMenu('categorias','mantenedores')">
                      <i class="far fa-circle nav-icon"></i>
                      <p>Categorias y Marcas</p>
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link :to="{name:'productos'}" class="nav-link"
                      :class="{'active':menuSeleccionado==='productos'}" 
                      @click="seleecionarMenu('productos','mantenedores')">
                      <i class="far fa-circle nav-icon"></i>
                      <p>Productos</p>
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link :to="{name:'modeloserie'}" class="nav-link"
                      :class="{'active':menuSeleccionado==='modeloserie'}" 
                      @click="seleecionarMenu('modeloserie','mantenedores')">
                      <i class="far fa-circle nav-icon"></i>
                      <p>Modelo-Serie-FV</p>
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link :to="{ name: 'proveedores'}" class="nav-link"
                      :class="{'active':menuSeleccionado==='proveedores'}" 
                      @click="seleecionarMenu('proveedores','mantenedores')">
                      <i class="far fa-circle nav-icon"></i>
                      <p>Proveedores</p>
                    </router-link>
                  </li>
                </ul>
              </li>
          
          <li class="nav-item"  v-if="tipoUsuario == 1">
            <a href="#" class="nav-link" :class="{'active':menuPrincipal==='empresa'}">
              <i class="nav-icon fas fa-city"></i>
              <p>
                Empresa
                <i class="right fas fa-angle-left"></i>
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link :to="{name:'configuracion'}" class="nav-link"
                  :class="{'active':menuSeleccionado==='configuracion'}" 
                  @click="seleecionarMenu('configuracion','empresa')">
                  <i class="far fa-circle nav-icon"></i>
                  <p>Configuracion</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link :to="{name:'comprobantes'}" class="nav-link"
                  :class="{'active':menuSeleccionado==='comprobantes'}" 
                  @click="seleecionarMenu('comprobantes','empresa')">
                  <i class="far fa-circle nav-icon"></i>
                  <p>Comprobantes</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link :to="{name:'sucursal'}" class="nav-link"
                  :class="{'active':menuSeleccionado==='sucursal'}" 
                  @click="seleecionarMenu('sucursal','empresa')">
                  <i class="far fa-circle nav-icon"></i>
                  <p>Sucursal Almacen</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link :to="{name:'usuarios'}" class="nav-link"
                  :class="{'active':menuSeleccionado==='usuarios'}" 
                  @click="seleecionarMenu('usuarios','empresa')">
                  <i class="far fa-circle nav-icon"></i>
                  <p>Usuarios</p>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
  </aside>
</template>
<script>
//Tipo Usuario: 1 Administrador, 2 Cajero, 3 Vendedor, 4 CajaVenta
  export default{
    
    data(){
      return{
        menuSeleccionado : '',
        menuPrincipal : '',
        nombreUsuario:'',
        tipoUsuario:'',
      }
    },
    methods:{
      seleecionarMenu(seleccionado,menuPrincipal){
        this.menuSeleccionado = seleccionado
        this.menuPrincipal = menuPrincipal
        
      }
    },
    mounted() {
        this.nombreUsuario = localStorage.getItem('username')
        this.tipoUsuario = localStorage.getItem('grupo_id')
        console.log(this.tipoUsuario+ ' perfil usuario')

        this.$watch(
            () => this.$route.path,
            () => {
            this.$nextTick(() => {
                this.$forceUpdate(); // 🔹 Hace que Vue actualice el menú cuando cambia la ruta
            });
            }
        );

    },
  }
</script>

<style>
    /* Fondo blanco */
.sidebar-light-custom {
    background: rgba(255,255,255,0.8) !important;
}

/* Texto de menu */
.sidebar .nav-link {
  color: rgba(0,0,0,0.7) !important;
  font-weight: 500;
}

/* Iconos */
.sidebar .nav-link .nav-icon {
  color: rgba(0,0,0,0.5) !important;
}

/* Hover */
.sidebar .nav-link:hover {
  background: rgba(0,0,0,0.05) !important;
  color: #000 !important;
}

/* Hover icon */
.sidebar .nav-link:hover .nav-icon {
  color: #000 !important;
}

/* Active */
.sidebar .nav-link.active {
  background: rgba(0,0,0,0.12) !important;
  color: #000 !important;
  font-weight: 600;
}

/* Active icon */
.sidebar .nav-link.active .nav-icon {
  color: #000 !important;
}

/* Submenus */
.nav-treeview .nav-link {
  padding-left: 2rem;
  color: rgba(0,0,0,0.6) !important;
}

.nav-treeview .nav-link:hover {
  background: rgba(0,0,0,0.05) !important;
}

/* Submenu active */
.nav-treeview .nav-link.active {
  background: rgba(0,0,0,0.15) !important;
  color: #000 !important;
}

/* Nombre del usuario */
.user-panel .info a {
  color: #555 !important;
  font-weight: 600;
}

/* Marca superior */
.brand-link {
    background: rgba(255,255,255,0.8) !important;
  border-bottom: 1px solid #f1f1f1;
}

.brand-link .brand-text {
  color: #333 !important;
  font-weight: bold;
}

aside.main-sidebar.elevation-4 {
    background: rgba(255,255,255,0.8) !important;
    backdrop-filter: blur(8px);
    box-shadow: 0 4px 16px rgba(0,0,0,0.1) !important;
    border-right: 1px solid rgba(255,255,255,0.3);
}

</style>